module.exports = __webpack_public_path__ + "static/media/SF_bm_primaerlogo_vestland_pos.01722d72.png";